export const inter = '"Inter", sans-serif';

/** Scoped overrides for `RequestTicket` / `GroupTicket` (global `.SuperVisor*` is 18px/14px for main ticket sidebar). */
export const tv2SuperVisorOverrides = {
  width: "100%",
  maxWidth: 248,
  "& .SuperVisor-Main-Container": {
    width: "100%",
    maxWidth: 248,
    boxSizing: "border-box",
    padding: "16px !important",
    borderRadius: "8px !important",
    border: "1px solid #E5E9EC !important",
    background: "#FFF !important",
    boxShadow: "none !important",
  },
  "& .SuperVisorText": {
    fontSize: "12px !important",
    fontStyle: "normal",
    fontWeight: "500 !important",
    lineHeight: "18px !important",
    color: "#061522 !important",
    fontFamily: `${inter} !important`,
  },
  "& .SuperVisorChange": {
    fontSize: "12px !important",
    lineHeight: "18px",
    color: "#148DFD !important",
    fontFamily: `${inter} !important`,
    fontWeight: "400 !important",
  },
  "& .SuperVisor-Logo-container": {
    marginTop: "12px !important",
    minWidth: 0,
  },
  "& .SuperVisor-Logo-container .MuiAvatar-root": {
    width: "32px !important",
    height: "32px !important",
    minWidth: "32px",
    fontSize: "13px !important",
  },
  "& .Super-Main-text": {
    minWidth: 0,
    flex: 1,
    overflow: "hidden",
  },
  "& .Super-Robert-text": {
    fontSize: "12px !important",
    fontStyle: "normal",
    fontWeight: "500 !important",
    lineHeight: "18px !important",
    color: "#061522 !important",
    fontFamily: `${inter} !important`,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  "& .Super-Kenzi-text": {
    fontSize: "12px",
    lineHeight: "18px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "100%",
  },
  "& .NoGroupSelectedMessage": {
    marginTop: "12px !important",
    width: "100% !important",
    maxWidth: "100%",
    height: "40px !important",
    minHeight: "40px !important",
    boxSizing: "border-box",
    borderRadius: "8px !important",
    background: "#F9FAFA !important",
    color: "#405261 !important",
    textAlign: "center !important",
    fontFamily: `${inter} !important`,
    fontSize: "12px !important",
    fontStyle: "normal",
    fontWeight: "400 !important",
    lineHeight: "18px !important",
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
    padding: "0 !important",
  },
  "& .truncate": {
    maxWidth: "100% !important",
  },
};

/** Card shell for Requester / Groups blocks (Figma detail bar). */
export const tv2UserDataCardSx = {
  width: 248,
  maxWidth: "100%",
  boxSizing: "border-box",
  p: 2,
  borderRadius: "8px",
  border: "1px solid #E5E9EC",
  background: "#FFF",
};

/** Empty slot for No Requester / No Group / No History (Figma). */
export const tv2EmptyPlaceholderSx = {
  width: 216,
  maxWidth: "100%",
  height: 40,
  borderRadius: "8px",
  background: "#F9FAFA",
  color: "#405261",
  textAlign: "center",
  fontFamily: inter,
  fontSize: 12,
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "18px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
};

export const tv2LinkActionSx = {
  color: "#148DFD",
  fontFamily: inter,
  fontSize: 12,
  fontWeight: 400,
  lineHeight: "18px",
  cursor: "pointer",
  userSelect: "none",
};

export const sxSectionTitle = {
  color: "#061522",
  fontFamily: inter,
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "18px",
};

export const sxMetaLabel = {
  color: "#405261",
  fontFamily: inter,
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
};

export const sxMetaDateValue = {
  color: "#061522",
  fontFamily: inter,
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "18px",
};

/** Shared MUI Select field styles for TicketV2 property dropdowns (status, priority). */
export const tv2PropertySelectSx = {
  width: 248,
  height: 40,
  borderRadius: "8px",
  fontFamily: inter,
  fontSize: "14px",
  bgcolor: "#FFF",
  boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
  color: "#405261",
  overflow: "hidden",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#D5DCE1 !important",
    borderRadius: "8px",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#D5DCE1 !important",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#D5DCE1 !important",
  },
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    height: "40px !important",
    minHeight: "unset !important",
    boxSizing: "border-box",
    py: "0 !important",
    pl: "12px",
    pr: "32px !important",
    fontSize: "14px",
    lineHeight: 1,
  },
  "& .MuiSelect-icon": {
    fontSize: "16px",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    right: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "& .MuiSelect-iconOpen": {
    transform: "translateY(-50%) rotate(180deg)",
  },
};

export const tv2SelectValueRowSx = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  height: "100%",
  minHeight: 0,
};

export const tv2SelectValueTypographySx = {
  fontSize: 14,
  color: "#061522",
  fontFamily: inter,
  fontWeight: 400,
  lineHeight: 1,
  display: "flex",
  alignItems: "center",
};

export const tv2SelectPlaceholderTypographySx = {
  fontSize: 14,
  color: "#8B97A2",
  fontFamily: inter,
  fontWeight: 400,
  lineHeight: 1,
  display: "flex",
  alignItems: "center",
};

export const selectMenuProps = {
  PaperProps: {
    sx: {
      border: "1px solid #D5DCE1",
      marginTop: "4px",
      width: "248px",
      padding: "0px 8px",
      borderRadius: "8px",
      boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
      "& .MuiMenuItem-root": {
        fontSize: "14px",
        padding: "8px 8px",
        color: "#405261",
        fontFamily: inter,
        transition: "none",
        "&:hover": {
          color: "#061522",
          borderRadius: "8px",
          background: "#F9FAFA !important",
        },
        "&.Mui-focusVisible": {
          borderRadius: "8px",
          background: "#F9FAFA !important",
        },
        "&.Mui-selected": {
          color: "#061522",
          borderRadius: "8px",
          background: "#F9FAFA !important",
        },
        "&.Mui-selected.Mui-focusVisible": {
          borderRadius: "8px",
          background: "#F9FAFA !important",
        },
        "&.Mui-selected:hover": {
          background: "#F9FAFA !important",
        },
      },
    },
  },
};

export const sectionHeaderButtonSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  py: 1.5,
  cursor: "pointer",
  bgcolor: "transparent",
  border: 0,
  fontFamily: inter,
};
